<template>
  <div class=""  @click="showSelect=false">
    <app-header />
    <div class="bannerWrap">
      <el-carousel>
        <el-carousel-item v-for="item in bannerList" :key="item.imgUrl" :style="item.color">
          <a href="#" @click="toBannerLinkUrl(item.linkUrl)">
            <img :src="item.imgUrl" />
          </a>
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel>
        <el-carousel-item v-for="item in bannerList2" :key="item.imgUrl" :style="item.color">
          <router-link :to="item.linkUrl" target="_blank">
            <img :src="item.imgUrl" />
          </router-link>
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <template v-if="productList.length > 0">
      <div class="wrap">
        <div class="r-select">
          <p class="cur-name fr" @click.stop="showSelect=!showSelect">全部产品</p>
          <ul class="r-select-list" v-show="showSelect">
            <li v-for="(pdt, index) in productList" :key="pdt.id"><router-link :to="'/product/' + productList[index].id" target="_blank">{{pdt.name}}</router-link></li>
          </ul>
        </div>
        <div class="mod-pdt">
          <div class="mod-pdt-column" @click="detailUrl(productList[0].id)">
            <div class="pdt-img">
              <img src="../../assets/images/home/product-img4.jpg" alt="" width="100%">
              <span class="tag-pdt">入门版</span>
            </div>
            <h3>大智慧「启航版」<img src="../../assets/images/home/338up.png" alt="" width="72.04px" height="45.43px"></h3>
            <p>{{productList[0].comment}}<router-link :to="'/product/' + productList[0].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a class="btn-operate fl" @click.stop="download(productList[0].downloadUrl)">下载软件</a>
              <a @click.stop="orderUrl(productList[0].id)" class="fr btn-buy">购买</a>
              <del class="del" v-show="productList[0].productPriceVos[0].oriPrice">¥{{productList[0].productPriceVos[0].oriPrice | amountFormat}}{{productList[0].productPriceVos[0].oriPrice | unitFormat}}/年</del>
              <span class="fr">¥{{productList[0].productPriceVos[0].curPrice | amountFormat}}{{productList[0].productPriceVos[0].curPrice | unitFormat}}/年</span>
            </div>
          </div>
          <div class="mod-pdt-column" @click="detailUrl(productList[1].id)">
            <div class="pdt-img">
              <img src="../../assets/images/home/product-img3.jpg" alt="" width="100%">
              <span class="tag-pdt">基础版</span>
            </div>
            <h3>大智慧「365」</h3>
            <p>{{productList[1].comment}}<router-link :to="'/product/' + productList[1].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a class="btn-operate fl"  @click.stop="download(productList[1].downloadUrl)">下载软件</a>
              <a @click.stop="orderUrl(productList[1].id)" class="fr btn-buy">购买</a>
              <span class="fr">¥{{productList[1].productPriceVos[0].oriPrice ? productList[1].productPriceVos[0].oriPrice : productList[1].productPriceVos[0].curPrice | amountFormat}}{{productList[1].productPriceVos[0].oriPrice ? productList[1].productPriceVos[0].oriPrice : productList[1].productPriceVos[0].curPrice | unitFormat}}/年</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mod-pdt-block mod-pdt-zyb" @click="detailUrl(productList[2].id)">
        <div class="wrap">
          <span class="tag-pdt">专业版</span>
          <div class="mod-pdt-column">
            <h3>大智慧「专业版」</h3>
            <p>{{productList[2].comment}}<router-link :to="'/product/' + productList[2].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a @click.stop="download(productList[2].downloadUrl)" class="btn-operate fl">下载软件</a>
              <a @click.stop="orderUrl(productList[2].id)" class="fr btn-buy">购买</a>
              <span class="fr">¥{{productList[2].productPriceVos[0].oriPrice ? productList[2].productPriceVos[0].oriPrice : productList[2].productPriceVos[0].curPrice | amountFormat}}{{productList[2].productPriceVos[0].oriPrice ? productList[2].productPriceVos[0].oriPrice : productList[2].productPriceVos[0].curPrice | unitFormat}}/年</span>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="mod-pdt">
          <div class="mod-pdt-column" @click="detailUrl(productList[3].id)">
            <div class="pdt-img">
              <img src="../../assets/images/home/product-img2.jpg" alt="" width="100%">
              <span class="tag-pdt">精通版</span>
            </div>
            <h3>大智慧「财富版」</h3>
            <p>{{productList[3].comment}}<router-link :to="'/product/' + productList[3].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a @click.stop="download(productList[3].downloadUrl)" class="btn-operate fl">下载软件</a>
              <a @click.stop="orderUrl(productList[3].id)" class="fr btn-buy">购买</a>
              <span class="fr">¥{{productList[3].productPriceVos[0].oriPrice ? productList[3].productPriceVos[0].oriPrice : productList[3].productPriceVos[0].curPrice | amountFormat}}{{productList[3].productPriceVos[0].oriPrice ? productList[3].productPriceVos[0].oriPrice : productList[3].productPriceVos[0].curPrice | unitFormat}}/年</span>
            </div>
          </div>
          <div class="mod-pdt-column" @click="detailUrl(productList[5].id)">
            <div class="pdt-img">
              <img src="../../assets/images/home/product-img1.jpg" alt="" width="100%">
              <span class="tag-pdt">HK行情</span>
            </div>
            <h3>大智慧港股通专业版</h3>
            <p>{{productList[5].comment}}<router-link :to="'/product/' + productList[5].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a @click.stop="download(productList[5].downloadUrl)" class="btn-operate fl">下载软件</a>
              <a @click.stop="orderUrl(productList[5].id)" class="fr btn-buy">购买</a>
              <span class="fr">¥{{productList[5].productPriceVos[0].oriPrice ? productList[5].productPriceVos[0].oriPrice : productList[5].productPriceVos[0].curPrice | amountFormat}}{{productList[5].productPriceVos[0].oriPrice ? productList[5].productPriceVos[0].oriPrice : productList[5].productPriceVos[0].curPrice | unitFormat}}/年</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="mod-pdt-block mod-pdt-ydgdb" @click="detailUrl(productList[6].id)">
        <div class="wrap">
          <span class="tag-pdt">移动高端版</span>
          <div class="mod-pdt-column">
            <h3>大智慧优选大师财富版<span>(仅限APP使用)</span></h3>
             <p>{{productList[6].comment}}<br><router-link :to="'/product/' + productList[6].id" target="_blank">查看详细...</router-link></p>
             <a @click.stop="orderUrl(productList[6].id)" class="fl btn-buy" target="_blank">
              <del>¥{{productList[6].productPriceVos[1].oriPrice | amountFormat}}{{productList[6].productPriceVos[1].oriPrice | unitFormat}}/年</del>
              <em>¥{{productList[6].productPriceVos[1].curPrice | amountFormat}}{{productList[6].productPriceVos[1].curPrice | unitFormat}}/年</em>购买</a>
          </div>
        </div>
      </div> -->
      <div class="mod-pdt-block mod-pdt-fxsb" @click="detailUrl(productList[4].id)">
        <div class="wrap">
          <span class="tag-pdt">分析师版</span>
          <div class="mod-pdt-column">
            <h3>大智慧策略投资终端</h3>
            <p>{{productList[4].comment}}<router-link :to="'/product/' + productList[4].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a @click.stop="download(productList[4].downloadUrl)" class="btn-operate fl">下载软件</a>
              <a @click.stop="orderUrl(productList[4].id)" class="fr btn-buy">购买</a>
              <span class="fr">¥{{productList[4].productPriceVos[1].oriPrice ? productList[4].productPriceVos[1].oriPrice : productList[4].productPriceVos[1].curPrice | amountFormat}}{{productList[4].productPriceVos[1].oriPrice ? productList[4].productPriceVos[1].oriPrice : productList[4].productPriceVos[1].curPrice | unitFormat}}/年</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mod-pdt-block mod-pdt-gdb" @click="detailUrl(productList[6].id)">
        <div class="wrap">
          <span class="tag-pdt">高端版</span>
          <div class="mod-pdt-column">
            <h3>大智慧VIP</h3>
            <p>{{productList[6].comment}}<router-link :to="'/product/' + productList[6].id" target="_blank">查看详细...</router-link></p>
            <div class="pdt-operate">
              <a @click.stop="download(productList[6].downloadUrl)" class="btn-operate fl">下载软件</a>
              <a @click.stop="orderUrl(productList[6].id)" class="fr btn-buy">购买</a>
              <span class="fr">
                <del class="del" v-show="productList[6].productPriceVos[3].oriPrice && productList[6].productPriceVos[3].oriPrice != productList[6].productPriceVos[3].curPrice">￥{{ productList[6].productPriceVos[3].oriPrice | amountFormat}} {{ productList[6].productPriceVos[3].curPrice | unitFormat}}/年</del>
                ¥{{productList[6].productPriceVos[3].curPrice | amountFormat}}{{ productList[6].productPriceVos[3].curPrice | unitFormat}}/年</span>            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="side-bar" :class="isFold?'':'side-bar-fold'">
      <a href="#">
        <dl>
          <dt>大智慧APP</dt>
          <dd>做股票投资、买基金、买保险就用大智慧</dd>
        </dl>
        <span class="btn">查看</span>
      </a>
      <div class="side-qr">
        <img src="../../assets/images/home/download-qr.png" alt="" width="100%">
        <p>扫码下载APP</p>
      </div>
      <span class="btn-fold" @click="isFold=!isFold"></span>
    </div>
    <home-footer />
    <!-- <bind-tel :info="info" v-show="isPop" @close="popColse"></bind-tel> -->
    <PartakePop v-show="isPartakePop" @close="popColse" :isHasTel="isHasTel"/>
  </div>
</template>

<script scope>
// import BindTel from '@/components/product/BindTel.vue'
import PartakePop from '@/components/product/PartakePop.vue'
import AppHeader from "@/components/common/AppHeader.vue";
import HomeFooter from "@/components/common/HomeFooter.vue";

export default {
  data() {
    return {
      token:this.$route.query.token,
      bannerList: [],
      bannerList2: [
        {
          linkUrl: '/product/335',
          imgUrl: require('../../assets/images/home/banner1.jpg'),
        },
        {
          linkUrl: '/activity/activity202204',
          imgUrl: require('../../assets/images/home/banner2.jpg'),
        }
      ],
      productList:[],
      isPop: false,
      info: {
        isWait: true,
        isBind: true,
        bindUrl: ''
      },
      // 试运行数据
      isPartakePop: false,
      isHasTel: false,
      isFold:false,
      navIndex:0,
      pdtList:['大智慧「启航版」','大智慧港股通专业版','大智慧「365」','大智慧财富大师','大智慧「专业版」','大智慧策略投资终端','大智慧「财富版」','大智慧信息投资终端'],
      showSelect:false,
    };
  },
  computed: {},
  created() {
    document.title = "大智慧股票软件网上商城";
    this.isBigBar()
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/index/web"+(this.token?"?token="+this.token:""))
        .then(response => {
          if (response.code === 0) {
            this.bannerList = response.data.bannerList;
            this.productList = response.data.productList;
            if(response.data.userName){
              this.$storage.saveUserName(response.data.userName);
            }
          } else {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    toBannerLinkUrl(linkUrl) {
      if (linkUrl != null && linkUrl != "") {
        window.open(linkUrl);
      }
      return false;
    },
    goUrl (key) {
      this.isPop = true
      this.$get('user/checkMobile').then(res =>{
        if(res.code === 0) {
          this.isPop = false
          this.$router.push({name: 'OrderConfirm', params:{productId: 335,month:12}})
        } else if(res.code === 107) {
          this.info.isWait = false
          this.info.isBind = false
          this.info.bindUrl = res.msg
        } else {
            this.$global.alert(res.msg);
          }
      }).catch(err => {
        this.$global.alertError();
      });
    },
    popColse (val) {
      // this.isPop = val
      this.isPartakePop = val
    },
    async goParkate () {
      let res = await this.$get('/product/checkTry')
      if (res.code === 0) {
        this.isPartakePop = true
        this.isHasTel = true
      } else if(res.code === 1) {
        this.isPartakePop = true
        this.isHasTel = false
      }
    },
    isBigBar(){
      // var w = $(window).width()
      var w = window.innerWidth
      if(w<1600){
        this.isFold = false
      }else{
        this.isFold = true
      }
    },
    // 跳转详情页
    detailUrl (val) {
      var newurl = this.$router.resolve({name: 'Product', params:{id: val}})
      window.open(newurl.href, '_blank')
    },
    // 下载软件
    download (val) {
      window.location.href = val
    },
    // 跳转购买页
    orderUrl (key, month=12) {
      var routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate;
      window.location.href = href + "?s=official";
    },
  },
  components: {
    AppHeader,
    HomeFooter,
    // BindTel,
    PartakePop
  }
};
</script>

<style scoped>
.bannerWrap /deep/ .el-carousel__container{
  height: 468px;
}
.el-carousel {
  height: 468px;
}
.el-carousel__item img {
  min-width: 1260px;
  height: 468px;
  display: block;
  margin: 0 auto;
}
.el-carousel__container .el-carousel__arrow {
  height: 60px;
  width: 60px;
  top: 50%;
  font-size: 30px;
}
/* .el-carousel__container .el-carousel__item{
  background: #523730;
}
.el-carousel__container .el-carousel__item:nth-of-type(2){
  background: #6336cb;
} */
.el-carousel__item a{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<style scoped>
div,span,nav,section,aside,article,ul,dl,dt,dd,li,a,p,h1,h2,h3,h4,h5,h6,i,b,em,strong,th,td,textarea,button,input,select,figure,figcaption {
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.wrap{width:95%;max-width: 1280px;margin: 0 auto;}
.r-select{padding: 12px 12px 0;position:relative;height: 54px;}
.cur-name{line-height:42px;background:#b2bbd1;border-radius:2px;padding: 0 22px;color: #fff;font-size: 18px;width: 220px;position:relative;cursor:pointer}
.cur-name:after{content:'';position:absolute;right:5px;top:13px;width:0;height:0;border:8px solid transparent;border-left:12px solid #fff;}
.r-select-list{position:absolute;right:0;top:68px;left:0;background:rgba(255,255,255,0.5);padding: 0 12px;z-index:4;}
.r-select-list li{float:left;width:49.5%;font-size: 34px;background:#1f3b84;border-radius:2px;line-height:110px;margin:0 1% 10px 0;padding: 0 40px;}
.r-select-list li:nth-of-type(even){margin-right:0;}
.r-select-list li a{color: #fff;display:block;}
.r-select-list li:hover{background:#111;}
.mod-pdt{overflow:hidden;padding: 25px 0 40px;cursor: pointer;}
.mod-pdt-column{float:left;margin:0 1%;width:48%;background:#f3f3f3;border-radius:2px;overflow:hidden;height:460px;position:relative;}
.pdt-img{position:relative;}
.tag-pdt{position:absolute;right:16px;bottom:18px;font-size:30px;color: #fff;}
.mod-pdt-column h3{font-size: 24px;color: #233569;padding:30px 40px 0;}
.mod-pdt-column p{font-size: 15px;color: #6e6e6e;line-height:1.8;padding: 10px 40px 0;}
.mod-pdt-column p a{color: #5d9bfe;}
.pdt-operate{padding: 0px 20px 28px 40px;font-size: 20px;color: #233569;overflow:hidden;line-height:34px;position:absolute;left:0;right:0;bottom:0;}
.pdt-operate a{border-radius:3px;text-align:center;line-height:35px;font-size: 15px;color: #233569;border:1px solid #233569;width: 58px;}
.pdt-operate a.btn-operate{display:block;width:86px;background:#859bd5;border-color:#859bd5;color: #fff;}
.btn-buy.fr{margin-left:14px;}
.mod-pdt-zyb{background:#707ad6;}
.mod-pdt-block .wrap{height:510px;position:relative;padding:110px 0 0 0;}
.mod-pdt-zyb .wrap{background:url('../../assets/images/home/product-bg2.png') no-repeat right bottom;}
.mod-pdt-ydgdb .wrap{background:url('../../assets/images/home/product-bg3.png') no-repeat 100% top;}
.mod-pdt-fxsb{background:url('../../assets/images/home/product-bg4.png') no-repeat center top;}
.mod-pdt-gdb .wrap{background:url('../../assets/images/home/product-bg5.jpg') no-repeat left top;}
.mod-pdt-zyb .tag-pdt{bottom: 110px;}
.mod-pdt-block .mod-pdt-column{background:none;height:260px;}
.mod-pdt-block .mod-pdt-column h3,.mod-pdt-block .mod-pdt-column p,.mod-pdt-block .pdt-operate,.mod-pdt-block .pdt-operate a{color: #fff;}
.mod-pdt-block .mod-pdt-column p a{color: #b4d1ff;}
.mod-pdt-zyb .pdt-operate a.btn-operate{background:#fff;color:#6293e1;border-color:#fff;}
.mod-pdt-zyb .pdt-operate a.btn-buy{border-color:#3761be;background:#3761be;}
.mod-pdt-ydgdb{background:#345489;}
.mod-pdt-ydgdb .mod-pdt-column h3{color: #afeaff;}
.mod-pdt-block .mod-pdt-column h3 span{font-size:15px;color:#fff;margin-left: 10px;}
.mod-pdt-ydgdb .btn-buy{line-height:34px;background:#2a3d80;font-size: 16px;border-color:#2a3d80;padding: 0 20px;color: #fff;border-radius:2px;margin:25px 0 0 40px;}
.mod-pdt-ydgdb .btn-buy del{color:#cbcbcb;font-size:12px;}
.mod-pdt-ydgdb .btn-buy em{margin: 0 40px 0 10px;}
.mod-pdt-fxsb{background-color:#bcc1ca;}
.mod-pdt-fxsb .mod-pdt-column h3,.mod-pdt-fxsb .pdt-operate,.mod-pdt-fxsb .pdt-operate a.btn-buy{color: #233569;}
.mod-pdt-fxsb .mod-pdt-column p{color: #6f6f6f;}
.mod-pdt-fxsb .mod-pdt-column p a{color: #5d9bfe;}
.mod-pdt-gdb{background:#1d191a;}
.mod-pdt-gdb .mod-pdt-column{float:right;width: 50%;}
.mod-pdt-gdb .pdt-operate a.btn-buy{color:#859bd5;border-color:#859bd5;}

.dl-swiper{position:absolute;right: 100px;top:128px;z-index:1;overflow:hidden;width: 412px;}
.dl-swiper-list{position:relative;}
.dl-swiper-list li{position:relative;float:left;}
.content .swiper-container-horizontal>.swiper-pagination-bullets,.content .swiper-pagination-custom,.content .swiper-pagination-fraction{bottom: 65px;}
.content .swiper-pagination-bullet{width: 12px;border-radius:0;background:#fff;opacity:1;height:4px;-ms-transition:width ease .5s;-webkit-transition:width ease .5s;transition:width ease .5s;}
.content .swiper-pagination-bullet-active{background:#709ad6;width: 25px;}
.content .swiper-button-next,.content .swiper-button-prev{top:auto;bottom: 43px;height:60px;width: 60px;border-radius:50%;}
.content .swiper-button-next:hover,.content .swiper-button-prev:hover{background:rgba(112,154,214,0.3);}
.content .swiper-button-prev{left: 50%;margin-left:-100px;}
.content .swiper-button-next{right: 50%;margin-right:-100px;}
.content .swiper-button-next:after,.content .swiper-button-prev:after{content:'';background-position:-30px -19px;width: 33px;height:9px;}
.content .swiper-button-next:after{-ms-transform:scaleX(-1);-webkit-transform:scaleX(-1);transform:scaleX(-1);}
.side-bar{position:fixed;right:10px;bottom:80px;padding:18px 25px;z-index:50;background:#e77734;width: 204px;cursor:pointer;}
.side-bar > a{display:block;background:url('../../assets/images/home/product-bar.png') no-repeat center top;padding-top:154px;color: #fff;}
.side-bar dl dt{font-size: 24px;}
.side-bar .btn{display:block;width: 60px;line-height:25px;font-size:12px;background:#282935;border-radius:2px;text-align:center;margin-top:5px;}
.side-qr{background:#fff;margin-top:20px;border-radius:2px;padding:8px 8px 5px;font-size: 15px;color:#282935;text-align:center;}
.side-bar dl dd{font-size: 15px;}
.btn-fold{position:absolute;left:50%;bottom:-40px;width:30px;height:30px;border:1px solid #b2b2b2;margin-left:-16px;border-radius:50%;}
.btn-fold:before,.side-bar-fold .btn-fold:after{content:'';position:absolute;left:50%;top:50%;background:#b2b2b2;-ms-transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}
.btn-fold:before{width: 60%;height:1px;}
.side-bar-fold .btn-fold:after{width: 1px;height:60%;}
.side-bar-fold.side-bar{background: url('../../assets/images/home/product-bar-s.png') no-repeat 0 0;width:67px;height:244px;bottom:100px;background-size: 100% auto;}
.side-bar-fold.side-bar a{display:none;}
.side-bar-fold.side-bar .side-qr{display:none;position:absolute;width: 166px;right: 80px;border-radius:10px;box-shadow:0 0 5px rgba(0,0,0,0.2);top:100px;}
.side-bar-fold.side-bar .side-qr:after{content:'';position:absolute;right:-20px;top:50%;width:0;height:0;border:10px solid transparent;border-left:10px solid #fff;margin-top:-10px;}
.side-bar-fold.side-bar:hover .side-qr{display:block}
.mod-pdt-block{cursor: pointer;}
.mod-pdt-column h3 em{
  font-size: 16px;
}
.pdt-operate del {
  font-size: 18px;
  color: #758bad;
  margin-left: 210px;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/Home.vue